const baseUrl = process.env.VUE_APP_ROOT_URL,
    shortBaseUrl = process.env.VUE_APP_SHORT_BASE_URL,
    apiBaseUrl = process.env.VUE_APP_API_BASE_URL,
    wsBaseUrl = process.env.VUE_APP_WS_URL,
    cacheSetting = process.env.VUE_APP_CACHE_SETTING == 'true',
    chatgptUrl = process.env.VUE_APP_CHATGPT_BASE_URL

const config = {
    meta: {
        "desc": "Create and play live quizzes. Test your skills, play and learn, test your team or simply play for fun. For home, work and school.",
        "keywords": "Quiz, live quiz, learning, play live, knowledge, education, geography, sports, movies, series, music, culture, history, science, technology, nature."
    },

    description: "live quiz & poll",
    baseUrl: baseUrl,
    shortBaseUrl: shortBaseUrl,
    apiBaseUrl: apiBaseUrl,
    wsBaseUrl: wsBaseUrl,
    cacheSetting: cacheSetting,
    wsPath: "",
    wsDebug: process.env.VUE_APP_WS_DEBUG == "false" ? false : true,
    defaultBackgroundColor: "#ef0000",
    passphraseKey: process.env.VUE_APP_PASSPHRASE_KEY,
    allwedUploadSize: process.env.VUE_APP_ALLOWED_UPLOAD_SIZE,
    allwedUploadVideoSize: process.env.VUE_APP_ALLOWED_UPLOAD_VIDEO_SIZE,
    cookieConsentName: process.env.VUE_APP_COOKIE_CONSENT_NAME,
    colors: {
        "#ef0000": "#770000",
        "#1fbc9c": "#015341",
        "#1ca085": "#014b3b",
        "#2ecc70": "#008136",
        "#27af60": "#006c2d",
        // '#3398db': '#006c2d',
        "#3398db": "#004675",
        "#2980b9": "#002945",
        "#a463bf": "#4c016c",
        "#8e43ad": "#490a63",
        "#3d556e": "#00152c",
        "#222f3d": "#0d1a27",
        "#f2c511": "#776005",
        "#e84b3c": "#960d00",
        "#c0382b": "#590800",
        "#f39c19": "#cc810f",
    },
    api: {
        fetchQuizById: apiBaseUrl + "quizzes/id/",
        fetchQuizByCode: apiBaseUrl + "quizzes/code/__id__",
        uploadImage: apiBaseUrl + "quizzes/upload-image",
        fetchImageSearch: apiBaseUrl + "images/search",
        generateImageSearch: apiBaseUrl + "images/keep",
        createQuiz: apiBaseUrl + "quizzes/create",
        sendCreateEmail: apiBaseUrl + "quizzes/create/email",
        updateQuiz: apiBaseUrl + "quizzes/update",
        updateQuestion: apiBaseUrl + "quizzes/id/__id__/questions",
        joinQuiz: apiBaseUrl + "quizzes/join",
        deleteMyQuiz: apiBaseUrl + "quizzes/__id__/delete-my-quiz",
        login3rd: apiBaseUrl + "users/3rd-login",
        checkEmail3rdParty: apiBaseUrl + "users/check-email-3rd-party",
        register: apiBaseUrl + "users/register",
        login: apiBaseUrl + "users/login",
        loginOtp: apiBaseUrl + "users/login-otp",
        loginGoogle2fa: apiBaseUrl + "users/login-google2fa",
        registerOneTime: apiBaseUrl + "users/register-one-time",
        setExpireOtp: apiBaseUrl + "users/expire-otp",
        otp: apiBaseUrl + "users/otp",
        resendRegister: apiBaseUrl + "users/resend-register",
        checkOneTime: apiBaseUrl + "users/check-one-time",
        refreshToken: apiBaseUrl + "refresh-token",
        unregister: apiBaseUrl + "users/unregister",
        getCountSuggestedUser: apiBaseUrl + "users/suggested-user",
        getGoogle2fa: apiBaseUrl + "users/google2fa",
        changeStatusGoogle2fa: apiBaseUrl + "users/change-status-google2fa",
        fetchQuestionByQuizCode: apiBaseUrl + "quizzes/code/__code__/random",
        saveQuestionResult: apiBaseUrl + "quizzes/__id__/save-question-result",
        fetchQuestionResult: apiBaseUrl + "quizzes/__id__/question-result",
        saveQuizResult: apiBaseUrl + "quizzes/__id__/save-quiz-result",
        validateToken: apiBaseUrl + "validate-token",
        yourQuiz: apiBaseUrl + "users/__id__/quizzes",
        joinedSponsorQuiz: apiBaseUrl + "users/__id__/joined-sponsor-quizzes",
        updateProfile: apiBaseUrl + "users/update-profile",
        createResetPasswordToken: apiBaseUrl + "users/create-reset-password",
        validateResetPasswordToken:
            apiBaseUrl + "users/validate-reset-password-token/__token__",
        resetPassword: apiBaseUrl + "users/reset-password/__token__",
        playTogether: apiBaseUrl + "quizzes/play-together/__id__",
        fetchQuizAndRandomById: apiBaseUrl + "quizzes/__id__/random",
        saveBuyPlayerOrder: apiBaseUrl + "save-buy-player-order",
        joinQuizValidation: apiBaseUrl + "quizzes/join-quiz-validation",
        fetchUserOrder: apiBaseUrl + "users/orders",
        fetchUserSubScription: apiBaseUrl + "users/subscriptions",
        unsubscribe: apiBaseUrl + "users/unsubscribe",
        validateSubscription: apiBaseUrl + "users/orders/validate-subscription",
        quizReport: apiBaseUrl + "reports/quiz",
        pollReport: apiBaseUrl + "reports/poll",
        playAloneReport: apiBaseUrl + "reports/playalone",
        playAloneReportXlsx: apiBaseUrl + "reports/playalone-xlsx",
        getReportByUser: apiBaseUrl + "reports/__id__",
        getReportAllByUser: apiBaseUrl + "quizzes/report-user-all",
        getSharedReportAll: apiBaseUrl + "quizzes/shared-report-user-all",
        newReport: apiBaseUrl + "reports/__id__/new",
        newIdentifyEmail: apiBaseUrl + "reports/__id__/identify-email",
        forceLoginWithFeide: apiBaseUrl + "reports/__id__/force-login-with-feide",
        updateWhitelistToReport: apiBaseUrl + "reports/__id__/update-whitelist-to-report",
        playaloneReportList: apiBaseUrl + "reports/__id__/playalone-list",
        sharedReportList: apiBaseUrl + "reports/__id__/shared-list",
        savePlayAloneReport: apiBaseUrl + "reports/__id__/playalone",
        saveNotLoggedInPlayAloneReport: apiBaseUrl + "not-logged-in-reports/__id__/playalone",
        listPlayerInReport: apiBaseUrl + "reports/__id__/players",
        downloadPdf: apiBaseUrl + "download-pdf/__token__",
        findOrderAbility: apiBaseUrl + "users/orders/ability",
        limitPlayer: apiBaseUrl + "users/orders/limit-player",
        getSubscriptionPlan: apiBaseUrl + "plans/subscription",
        fetchFrontPageSetting: cacheSetting ? "/setting.json" : (apiBaseUrl + "setting"),
        getCategoryTags: apiBaseUrl + "tags/all",
        getQuizRelateCategory: apiBaseUrl + "quizzes/relate-category",
        saveQuizPlaying: apiBaseUrl + "quizzes/__id__/playing",
        getQuizPlaying: apiBaseUrl + "quizzes/__id__/playing",
        shareQuiz: apiBaseUrl + "quizzes/share",
        setUserShareQuiz: apiBaseUrl + "quizzes/share/__id__/__token__",
        fetchSharedUser: apiBaseUrl + "quizzes/__id__/shared-user",
        deleteSharedUser: apiBaseUrl + "quizzes/share/__id__",
        getQuizByUser: apiBaseUrl + "quizzes/get-quiz-report",
        toggleQuizStatus: apiBaseUrl + "quizzes/__id__/toggle-status",
        sendContact: apiBaseUrl + "contacts",
        sendContributor: apiBaseUrl + "contributors",
        shareLink: apiBaseUrl + "share-link",
        cacheSpotifySong: apiBaseUrl + "song-question/cache",
        playWith: apiBaseUrl + "play-with",
        setLastActivity: apiBaseUrl + "users/__id__/activity-timestamp",
        setUserPlayType: apiBaseUrl + "users/__id__/playing-count",
        applyToCreator: apiBaseUrl + "users/apply-creator",
        getCredit: apiBaseUrl + "users/credit/__id__",
        fetchMenu: apiBaseUrl + "page-menues",
        fetchPageBySlug: apiBaseUrl + "page-slug",
        saveCoin: apiBaseUrl + "users/coin",
        createLog: apiBaseUrl + "logs",
        createStripeCharge: apiBaseUrl + "users/stripe/create-charge",
        validateCaptcha: apiBaseUrl + "users/stripe/validate-captcha",
        stripeCreateSession: apiBaseUrl + "users/stripe/create-session",
        stripeCreateSubscriptionOrder: apiBaseUrl + "users/stripe/create-order",
        stripeUnsubscribe: apiBaseUrl + "users/stripe/unsubscribe",
        createPaymentIntent: apiBaseUrl + "users/stripe/intent",
        removePaymentIntent: apiBaseUrl + "users/stripe/cancel-intent",
        getUserCountry: apiBaseUrl + "geo-country",
        vippsCreatePayment: apiBaseUrl + "users/vipps/create-payment",
        vippsCreatePaymentSubscription: apiBaseUrl + "users/vipps/create-payment-subscription",
        vippsOrderDetail: apiBaseUrl + "users/vipps/order-detail",
        vippsCreateSubscriptionOrder: apiBaseUrl + "users/vipps/create-subscription-order",
        vippsCheckTokenCode: apiBaseUrl + "users/vipps/check-order-token",
        vippsUnsubscribe: apiBaseUrl + "users/vipps/unsubscribe",
        vippsSubscriptionPending: apiBaseUrl + "users/vipps/subscription-pending",
        updateShowNewsletter: apiBaseUrl + "users/update-show-newsletter",
        updateNewsletterEmail: apiBaseUrl + "users/update-newsletter-email",
        categoryScore: apiBaseUrl + "quizzes/category/score/__id__",
        saveSponsorQuizScore: apiBaseUrl + "quizzes/sponsor-quiz-score",
        saveSponsorQuizTracker: apiBaseUrl + "quizzes/sponsor-quiz-tracker",
        updateUserInfoInRanking: apiBaseUrl + "quizzes/sponsor-quiz-score/info",
        getRankingInfo: apiBaseUrl + "quizzes/sponsor-quiz-ranking-info/__id__",
        getNewsletterPopupStatus: apiBaseUrl + "users/newsletter-popup-status",
        unsubscribeNewsletter: apiBaseUrl + "users/newsletter-unsubscribe",
        createSponsorQuizShareLink: apiBaseUrl + "quizzes/sponsor-quiz-share-link",
        getEmbed: apiBaseUrl + "quizzes/embed/__id__",
        saveSurvey: apiBaseUrl + "quizzes/survey",
        getLimitAiQuestionByUser: apiBaseUrl + "quizzes/limit-ai-question",
        getLimitAiImageByUser: apiBaseUrl + "quizzes/limit-ai-image",
        setAiImageByUser: apiBaseUrl + "quizzes/set-ai-image",
        setAiQuestionByUser: apiBaseUrl + "quizzes/set-ai-question",
        confirmEmail: apiBaseUrl + "users/confirm-email",
        sendEmailQuizPlayLive: apiBaseUrl + "quizzes/send-email-quiz-play-live",
        setStatusFreeTrial: apiBaseUrl + "users/set-status-free-trial",
        getStatusFreeTrial: apiBaseUrl + "users/get-status-free-trial/__token__",
        resendToEmail: apiBaseUrl + "users/resend-to-email",
        getCouponStatus: apiBaseUrl + "users/get-coupon",
        registerSchool: apiBaseUrl + "users/register-school",
        checkSchoolOneTime: apiBaseUrl + "users/check-school-one-time",
        getSlug: apiBaseUrl + "users/get-slug",
        schoolMyQuizzes: apiBaseUrl + "users/school-my-quizzes",
        getSchoolSubject: apiBaseUrl + "users/__slug__/school-subject",
        getSchoolSubjectById: apiBaseUrl + "users/__id__/get-school-subject",
        getSchool: apiBaseUrl + "users/__id__/get-school",
        validateRegisterOtp: apiBaseUrl + "users/validate-register-otp",
        checkUpdateShowOneTimeOffer: apiBaseUrl + "users/check-update-show-one-time-offer",
        getShowOneTimeOffer: apiBaseUrl + "users/get-show-one-time-offer",
        getOneTimeOfferPlan: apiBaseUrl + "plans/one-time-offer",
        generateDescriptionByAi: chatgptUrl + "/quiz/generate-description",
        setLimitAiQuestionByUser: apiBaseUrl + "users/set-limit-ai-question-by-user",
        getAffiliateAllByUserPartner: apiBaseUrl + "partners/affiliate-user-all",
        getPayoutByUser: apiBaseUrl + "partners/payout-by-user",
        getInvoice: apiBaseUrl + "invoices/__id__",
        getStripeReceipt: apiBaseUrl + "invoices/receipt/__id__",
        getReceipt: apiBaseUrl + "invoices/receipt/__id__",
        getInvoicePayment: apiBaseUrl + "invoices/payment/__id__",
        unsubscribeNewsletterGuest: apiBaseUrl + "users/unsubscribe-guest",
        switchAccount: apiBaseUrl + "users/switch-account",
        createUserGuests: apiBaseUrl + "users/create-user-guest",
        copyToMyQuiz: apiBaseUrl + "quizzes/__id__/copy-to-myquiz",
        getUserInSchool: apiBaseUrl + "school-admins/users",
        updateSchoolUserStatus: apiBaseUrl + "school-admins/users/update-status",
        inviteUsers: apiBaseUrl + "school-admins/users/invite",
        removeQuizFromLibrary: apiBaseUrl + "school-admins/quizzes/remove-from-library",
        getSubjects: apiBaseUrl + "school-admins/settings/subjects",
        updateSubjects: apiBaseUrl + "school-admins/settings/update-subject",
        checkSchoolAdmin: apiBaseUrl + "school-admins/users/check-school-admin",
        updateSchoolAdminStatus: apiBaseUrl + "school-admins/users/update-admin-status",
        updateSchool: apiBaseUrl + "school-admins/settings/update-school",
        getSchoolRequests: apiBaseUrl + "school-admins/users/access-request",
        addToSchool: apiBaseUrl + "school-admins/users/add-to-school",
        inviteToSchool: apiBaseUrl + "school-admins/users/invite",
        rejectAccessSchool: apiBaseUrl + "school-admins/users/reject-accesss-request",
        createSchoolWhitelist: apiBaseUrl + "school-whitelists",
        updateSchoolWhitelist: apiBaseUrl + "school-whitelists/__id__",
        getSchoolWhitelist: apiBaseUrl + "school-whitelists",
        getSchoolWhitelistAll: apiBaseUrl + "school-whitelists/list",
        deleteSchoolWhitelist: apiBaseUrl + "school-whitelists/__id__",
        cloneSchoolWhitelist: apiBaseUrl + "school-whitelists/__id__/clone",
        getQuizLogs: apiBaseUrl + "quiz-logs/__id__",
        createQuizLogs: apiBaseUrl + "quiz-logs",
        updateShareSetting: apiBaseUrl + "quizzes/__id__/update-share-setting",
        getMergeReports: apiBaseUrl + "merge-reports",
        getMergeReportById: apiBaseUrl + "merge-reports/__id__",
        createMergeReport: apiBaseUrl + "merge-reports",
        updateMergeReport: apiBaseUrl + "merge-reports/__id__",
        deleteMergeReport: apiBaseUrl + "merge-reports/__id__",
        updateMergeReportStatus: apiBaseUrl + "merge-reports/__id__/update-status",
        updateReportRanking: apiBaseUrl + "reports/__id__/update-report-ranking",
        updateLockStatus: apiBaseUrl + "reports/__id__/update-lock-status",
        searchMusic: apiBaseUrl + "music/search",
    },
    payPlayerPlans: [
        {
            id: 1,
            price: 4.5,
            priceKr: 45,
            limitPlayer: 20,
        },
        {
            id: 2,
            price: 9,
            priceKr: 90,
            limitPlayer: 30,
        },
        {
            id: 3,
            price: 15,
            priceKr: 150,
            limitPlayer: 50,
        },
        {
            id: 4,
            price: 30,
            priceKr: 300,
            limitPlayer: 100,
        },
    ],
    buyCreditPlan: [
        {
            id: 1,
            price: 9,
            priceKr: 90,
            credit: 10,
        },
        {
            id: 2,
            price: 17,
            priceKr: 170,
            credit: 20,
        },
        {
            id: 3,
            price: 40,
            priceKr: 400,
            credit: 50,
        },
        {
            id: 4,
            price: 70,
            priceKr: 700,
            credit: 100,
        },
        {
            id: 5,
            price: 250,
            priceKr: 2500,
            credit: 500,
        },
    ],
    spotify: {
        clientId: process.env.VUE_APP_SPOTIFY_CLIENT_ID,
        clientSecret: process.env.VUE_APP_SPOTIFY_CLIENT_SECRET,
    },

    supportedLanguages: ['en', 'no', 'se', 'dk', 'fr', 'de', 'es'],

    delayPuzzleDone: 2,

    countdownOtp: 30,

    maxShowOneTimeOffer: 5,

    maxFreeUserQuiz: 5,

    aiQuestionPlan: [
        {
            'id': 1,
            'price': 5,
            'nok_amount': 50,
            'limit': 100,
            'image_generation_limit': 20
        },
        {
            'id': 2,
            'price': 10,
            'nok_amount': 100,
            'limit': 500,
            'image_generation_limit': 40
        },
        {
            'id': 3,
            'price': 15,
            'nok_amount': 150,
            'limit': 1000,
            'image_generation_limit': 75
        }
    ]
};

export default config
